module.exports = __webpack_public_path__ + "assets/img/help_panel.f4f4f27f.svg";